var duck_and_dry;
(function($) {
  "use strict";
  duck_and_dry = (function() {
    return {
      init: function() {
        // Header
        this.mobileMenu();
        this.shoppingCart();
        this.popupNewsletter();
        this.fixedHeader();

        // Home Sections
        if($("body.index").length > 0) {
          this.hero();
          this.popularProducts();
          this.looks();
          this.ourSalons();
          this.quotes();
          this.latestPosts();
        }

        // Collection page
        if($("body.collection").length > 0) {
          this.collectionQuotes();
          this.latestPosts();
        }

        // Product page
        if($("body.product").length > 0) {
          this.productImages();
          this.relatedProducts();
          this.manageForm();
          this.howToUse();
        }

        // Blog page
        if($("body.blog").length > 0) {
          this.blogPage();
        }
        if($("#article").length > 0) {
          this.latestPosts();
        }
        if($(".custom-article-products").length > 0) {
          this.popularProducts();
        }

        // Pages
        if($(".page_salon").length > 0) {
          this.salonPage();
        }
        if($("#login").length > 0) {
          this.accountPage();
        }
        if($(".page_looks").length > 0) {
          this.popularProducts();
          this.latestPosts();
          this.looksPage();
        }
        if($("body.page_services").length > 0 || $("body.page_services2").length > 0 || $("body.page_services3").length > 0) {
          this.looks();
          this.latestPosts();
          this.quotes();
        }
        if($("body.page_private_hire").length > 0 || $("body.page_private_hire_v2").length > 0) {
          this.privateHirePage();
        }
        if($("body.page_story").length > 0 || $("body.page_story2").length > 0) {
          this.storyPage();
        }
        if($("#faq-page").length > 0) {
          this.faqPage();
        }
        if($("body.page_franchise").length > 0) {
          this.franchisePage();
        }
        this.services2Page();

        // Scripts, effects
        this.lazyImages();
        this.addToCartGrid();
        this.buttonHoverEffect();
        this.changeQuantity();
        this.detectBrowser();
      },

      mobileMenu: function() {
        $("header .navbar #navbarNav .navbar-nav .nav-item .open-sub-menu").click(function () {
          if($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this).parent().removeClass("active").find(".sub-menu").hide(400);
          } else {
            $(this).addClass("active");
            $(this).parent().addClass("active").find(".sub-menu").show(400);
          }
        });
      },

      shoppingCart: function() {
        $("body").on("click", "header .right .cart .cart-count, header .right .cart .cart-content .continue-shopping a", function () {
          if($("header .right .cart").hasClass("active")) {
            $("header .right .cart").removeClass("active");
          } else {
            $("header .right .cart").addClass("active");
          }
          return false;
        });
        $("body").on("click", ".close-cart", function () {
          $("header .right .cart").removeClass("active");
        });
      },

      popupNewsletter: function() {
        if($("#newsletter").length > 0) {
          if(!$.cookie('newsletter')) {
            setTimeout(function () {
              $("#newsletter").addClass("active");
            }, $("#newsletter").attr("data-show-after"));
          }

          $("#newsletter .close-newsletter").click(function () {
            $.cookie('newsletter', 'true', { expires : 72000 });
            $("#newsletter").removeClass("active");
            return false;
          });
        }
      },

      fixedHeader:function(){
        var header=document.getElementById("header");
        if(!header) return;
        var section=header.closest(".header-section")||header.parentElement;
        function reserve(){ section.style.height=header.offsetHeight+"px"; }
        reserve();
        window.addEventListener("resize",reserve);
        function menuIsOpen(){
          var nav=document.getElementById("navbarNav");
          var toggler=document.querySelector(".navbar-toggler");
          return (nav && nav.classList.contains("show")) ||
                (toggler && toggler.getAttribute("aria-expanded")==="true") ||
                (toggler && !toggler.classList.contains("collapsed"));
        }
        var lastScrollTop=0;
        window.addEventListener("scroll",function(){
          var currentScroll=window.scrollY||window.pageYOffset;
          var hero=document.getElementById("hero");
          var hideThreshold=hero?hero.offsetHeight:Math.round(window.innerHeight*0.9);
          var isScrollingDown=currentScroll>lastScrollTop;
          if(menuIsOpen()){
            header.classList.remove("nav-hidden");
          }else if(isScrollingDown && currentScroll>=hideThreshold){
            header.classList.add("nav-hidden");
          }else if(!isScrollingDown){
            header.classList.remove("nav-hidden");
          }
          lastScrollTop=currentScroll;
        });
      },

      // Home Sections
      hero: function() {
        $("hero").removeClass("active");
        if($("#hero img").length > 0) {
          var load_images = setInterval(function () {
            if($("#hero .image").hasClass("active")) {
              setTimeout(function() { $("#hero").addClass("active"); }, 200);
              clearInterval(load_images);
            }
          }, 200);
        } else {
          $("#hero video").each(function() {
            this.controls = false;
          });

          if($("#hero video, #hero iframe").length > 0) {
            $("#hero video").each(function() {
              $(this).get(0).play();
            });

            $("#hero iframe").each(function() {
              var iframe = $(this)[0],
                  player = $f(iframe);

              player.addEvent('ready', function() {
                player.api('setVolume', 0);
                player.api('play');
              });
            });

            setTimeout(function() { $("#hero").addClass("active"); }, 1000);
          }
        }
      },

      popularProducts: function() {
        $("#popular-products .owl-carousel").owlCarousel({
          items: 3,
          margin: 3,
          nav: true,
          dotsData: true,
          autoplay: true,
          autoplayTimeout: 4000,
          responsive: {
            0: {
              items: 1
            },
            768: {
              items: 2
            },
            992: {
              items: 3
            }
          },
          loop: false,
          rewind: true
        });
      },

      looks: function() {
        function resize() {
          $("#looks .left-box .background").css("left", "0px").css("right", "0px");
          var left = $("#looks .left-box .background").offset().left;
          var right = $("body").outerWidth() - $("#looks .left-box .background").offset().left - $("#looks .left-box .background").outerWidth();
          $("#looks .left-box .background").css("left", "-" + left + "px").css("right", "-" + right + "px");
        }

        function imageSlider() {
          $("#looks .right-box").each(function () {
            var $rb = $(this);
            var mobile = window.matchMedia("(max-width: 767px)").matches;
            var inited = $rb.hasClass("owl-loaded");
            if (mobile && !inited && $rb.find(".item").length > 1) {
              $rb.addClass("owl-carousel").owlCarousel({ items: 1, margin: 20, nav: false, autoplay: false });
            } else if (!mobile && inited) {
              $rb.trigger("destroy.owl.carousel").removeClass("owl-carousel owl-loaded");
            }
          });
        }

        if ($("#looks").length > 0) {
          resize();
          $(window).on("load resize", function() {
            resize();
          });

          imageSlider();
          $(window).on("load", imageSlider);
          window.matchMedia("(max-width: 767px)").addEventListener("change", imageSlider);
        }
      },

      ourSalons: function() {
        var current = 1;
        var interval = false;
        $("#our-salons ul li a").hover(function() {
          var index = $(this).attr("data-index");
          current = index;
          $("#our-salons ul li a").removeClass("active");
          $(this).addClass("active");
          $("#our-salons .images .image").removeClass("active");
          $("#our-salons .images .image[data-index='" + index + "']").addClass("active");
          clearInterval(interval);
          interval = setInterval(function () {
            autoChangeSalons();
          }, 7000);
        });
        interval = setInterval(function () {
          autoChangeSalons();
        }, 7000);
        function autoChangeSalons() {
          current++;
          if($("#our-salons ul li a[data-index='" + current + "']").length == 0) {
            current = 1;
          }
          $("#our-salons ul li a").removeClass("active");
          $("#our-salons ul li a[data-index='" + current + "']").addClass("active");
          $("#our-salons .images .image").removeClass("active");
          $("#our-salons .images .image[data-index='" + current + "']").addClass("active");
        }
      },

      quotes: function() {
        $("#quotes .owl-carousel").owlCarousel({
          items: 1,
          margin: 20,
          nav: true,
          loop: true,
          autoplay: true,
          smartSpeed: 500,
          autoplayTimeout: 6000
        });
      },

      latestPosts: function() {
        $("#latest-posts .owl-carousel").owlCarousel({
          items: 3,
          margin: 3,
          nav: true,
          dotsData: true,
          autoplay: true,
          autoplayTimeout: 4000,
          responsive: {
            0: {
              items: 1
            },
            768: {
              items: 2
            },
            992: {
              items: 3
            }
          },
          loop: false,
          rewind: true
        });
      },

      // Collection page
      collectionQuotes: function() {
        $("#collection-quotes .owl-carousel").owlCarousel({
          items: 1,
          margin: 20,
          nav: true,
          loop: true,
          autoplay: true,
          smartSpeed: 500,
          autoplayTimeout: 6000
        });
      },

      // Product page
      productImages: function() {
        $("#product .product-template .left .thumbnails .item").click(function () {
          $("#product .product-template .left .thumbnails .item").removeClass("current");
          $(this).addClass("current");
          $("#product .product-template .left .image").removeClass("active");
          $("#product .product-template .left .image img").attr("data-retina-src", $(this).attr("data-retina-src"));
          $("#product .product-template .left .image img").attr("data-src", $(this).attr("data-src"));
          $("#product .product-template .left .image img").attr("data-retina-mobile-src", $(this).attr("data-retina-mobile-src"));
          $("#product .product-template .left .image img").attr("data-mobile-src", $(this).attr("data-mobile-src"));
          $("#product .product-template .left .image img").attr("src", "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=");
          $('#product .product-template .left .image').attr("href", $(this).attr("href"));
          duck_and_dry.lazyImages();
        }); 
        $('#product .product-template .left .image, #product .product-template .left .owl-carousel .item').magnificPopup({ 
          type: 'image'
        });
        $("#product .product-template .left .owl-carousel").owlCarousel({
          items: 1,
          margin: 0,
          nav: true,
          autoplay: false
        });
      },

      relatedProducts: function() {
        if($(".product-recommendations").length > 0) {
          loadRelatedProducts();
        }
        if($(".custom-related-products").length > 0) {
          duck_and_dry.popularProducts();
        }
        function loadRelatedProducts() {
          var productRecommendationsSection = document.querySelector(".product-recommendations");
          if (productRecommendationsSection === null) { return; }
          var productId = $(".product-recommendations").attr("data-product-id");
          var limit = $(".product-recommendations").attr("data-limit");
          var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
          var request = new XMLHttpRequest();
          request.open("GET", requestUrl);
          request.onload = function() {
            if (request.status >= 200 && request.status < 300) {
              var container = document.createElement("div");
              container.innerHTML = request.response;
              productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
              duck_and_dry.popularProducts();
              duck_and_dry.lazyImages();
            }
          };
          request.send();
        }
      },

      manageForm: function() {
        function quantity() {
          $("#product .product-template .right form .quantity .quantity-down").click(function () {
            var q_val_up = parseInt($("#product .product-template .right form .quantity input").val());
            if(isNaN(q_val_up)) {
              q_val_up = 0;
            }
            if(q_val_up > 1) {
              $("#product .product-template .right form .quantity input").val(q_val_up-1).keyup();
            } 
            return false; 
          });

          $("#product .product-template .right form .quantity .quantity-up").click(function () {
            var q_val_up = parseInt($("#product .product-template .right form .quantity input").val());
            if(isNaN(q_val_up)) {
              q_val_up = 0;
            }
            $("#product .product-template .right form .quantity input").val(q_val_up+1).keyup(); 
            return false; 
          });
        }

        function addToCart() {
          $("#product .product-template .right .form-button").addClass("loading");
          var quantity = $("#product .product-template .right form .quantity input").val();
          if(isNaN(quantity)) { quantity = 1; }
          var id = $("#product-select").val();
          var properties = {};
          if($("input[name='properties[Recipients Email]']").length > 0) {
            properties = {'Recipients Email': $("input[name='properties[Recipients Email]']").val(), 'Type': $("select[name='properties[Type]']").val()};
          }
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: { id: id, quantity: quantity, properties: properties },
            success: function() {
              duck_and_dry.refreshCart();
            },
            error: function(response) {
              var errorMessage = response.responseJSON
                ? response.responseJSON.description
                : theme.strings.cartError;
              alert(errorMessage);
              duck_and_dry.refreshCart();
            }
          });
        }

        function variants() {
          var data = JSON.parse(document.getElementById('ProductJson').innerHTML);
          var selectCallback = function(variant, selector) {
            if (variant) {
              if (variant.available) {
                $("#product .product-template .right form .form-button.add-to-cart, #product .product-template .right form .quantity").removeClass("d-none");
                $("#product .product-template .right form .form-button.out-of-stock").addClass("d-none");
              } else {
                $("#product .product-template .right form .form-button.add-to-cart, #product .product-template .right form .quantity").addClass("d-none");
                $("#product .product-template .right form .form-button.out-of-stock").removeClass("d-none");
              }
              $('#product .product-template .right form .form-button .price').html(Shopify.formatMoney(variant.price));
            } else {
                $("#product .product-template .right form .form-button.add-to-cart, #product .product-template .right form .quantity").addClass("d-none");
              $("#product .product-template .right form .form-button.out-of-stock").removeClass("d-none");
            }
          }
          jQuery(function($) {
            new Shopify.OptionSelectors("product-select", { product: data , onVariantSelected: selectCallback, enableHistoryState: true });
          });
        }

        $("#product .product-template .right form .form-button.add-to-cart").click(function () {
          addToCart();
        });

        $("body").on("click", "#product .product-template .right form .form-button.out-of-stock", function() {
          $(".bis-reset").click();
        });

        quantity();
        variants();
      },

      howToUse: function() {
        $("#product #how-to-use .right .image").click(function () {
          $("#product #how-to-use .right").addClass("active");
          $("#product #how-to-use .right video").each(function() {
            $(this).get(0).play();
          });

          $("#product #how-to-use .right iframe").each(function() {
            var iframe = $(this)[0],
                player = $f(iframe);

            player.addEvent('ready', function() {
              player.api('play');
            });
          });
        });
      },

      // Blog page
      blogPage: function() {
        var level = 1;
        if($("#blog .posts .post.level-2").length > 0) {
          $("#blog #more .button").click(function () {
            level++;
            $("#blog .posts").attr("data-level", level);
            var level2 = level+1;
            if($("#blog .posts .post.level-" + level2).length == 0) {
              $("#blog #more").hide();
            }
            return false;
          });
        } else {
          $("#blog #more").hide();
        }
      },

      // Pages
      salonPage: function() {
        $("#salon .gallery .owl-carousel").owlCarousel({
          items: 1,
          margin: 3,
          nav: true,
          autoplay: true,
          autoplayTimeout: 4000,
          loop: true
        });
        duck_and_dry.ourSalons();
      },

      accountPage: function() {
        function showRecoverPasswordForm() {
          return $("#recover-password").fadeIn(), $("#customer-login").hide(), window.location.hash="#recover";
        }

        function showLoginForm() {
          return $("#recover-password").hide(), $("#customer-login").fadeIn(), window.location.hash="";
        }

        $("#forgot-password a").click(function() {
          showRecoverPasswordForm();
        });

        $("#recover-password a.cancel").click(function() {
          showLoginForm();
        });

        if("#recover" == window.location.hash) {
          showRecoverPasswordForm()
        } else {
          showLoginForm();
        }
      },

      looksPage: function() {
        $('#looks-2 .content .owl-carousel').owlCarousel({
          items: 1,
          loop: true,
          margin: 0,
          animateOut: 'animate__fadeOutDown',
          animateIn: 'animate__fadeInDown',
          mouseDrag: false,
          touchDrag: false,
          smartSpeed: 900
        });
        $('#looks-2 .main-image .owl-carousel').owlCarousel({
          items: 1,
          loop: true,
          margin: 0,
          mouseDrag: false,
          touchDrag: false,
          smartSpeed: 900
        });
        $('#looks-2 .second-image .owl-carousel').owlCarousel({
          items: 1,
          startPosition: 1,
          loop: true,
          margin: 0,
          mouseDrag: false,
          touchDrag: false,
          smartSpeed: 900
        });
        $('#looks-2 .third-image .owl-carousel').owlCarousel({
          items: 1,
          startPosition: 2,
          loop: true,
          margin: 0,
          mouseDrag: false,
          touchDrag: false,
          smartSpeed: 900
        });
        $('#looks-2 .play-video').each(function() {
          if($(this).hasClass("mp4")) {
            $('.popup-with-video').magnificPopup({
              type: 'inline',
              preloader: false,
              callbacks: {
                open: function () {
                  $(this.content).find('video')[0].play();
                },
                close: function () {
                  $(this.content).find('video')[0].pause();
                }
            }
            });
          } else {
            $(this).magnificPopup({
              delegate: 'a',
              type: 'image',
              gallery: {
                enabled:true
              }
            });
          }
        });
        $(".custom-owl-next").click(function() {
          $(".custom-owl-prev").removeClass("disabled");
          $('#looks-2 .active .content .owl-carousel, #looks-2 .active .main-image .owl-carousel, #looks-2 .active .second-image .owl-carousel, #looks-2 .active .third-image .owl-carousel').trigger('next.owl.carousel');
        });
        $(".custom-owl-prev").click(function() {
          $('#looks-2 .active .content .owl-carousel, #looks-2 .active .main-image .owl-carousel, #looks-2 .active .second-image .owl-carousel, #looks-2 .active .third-image .owl-carousel').trigger('prev.owl.carousel');
        });
        $("#looks-2 .looks-list li a").click(function () {
          $("#looks-2 .looks-list li a").removeClass("active");
          $(this).addClass("active");
          $("#looks-2 .container > div").removeClass("active").hide();
          $("." + $(this).attr("data-go")).addClass("active").fadeIn();
          return false;
        });
        // remove duplicate <h3>s Owl creates in its loop clones (keeps the loop working)
        $('#looks-2 .owl-item.cloned h3').remove();
      },

      privateHirePage: function() {
        function resize() {
          $("#private-hire-corp .left-box .background").css("left", "0px").css("right", "0px");
          var left = $("#private-hire-corp .left-box .background").offset().left;
          var right = $("body").outerWidth() - $("#private-hire-corp .left-box .background").offset().left - $("#private-hire-corp .left-box .background").outerWidth();
          $("#private-hire-corp .left-box .background").css("left", "-" + left + "px").css("right", "-" + right + "px");
        }

        function imageSlider() {
          $("#private-hire-corp .right-box").each(function () {
            var $rb = $(this);
            var mobile = window.matchMedia("(max-width: 767px)").matches;
            var inited = $rb.hasClass("owl-loaded");
            if (mobile && !inited && $rb.find(".item").length > 1) {
              $rb.addClass("owl-carousel").owlCarousel({ items: 1, margin: 20, nav: false, autoplay: false });
            } else if (!mobile && inited) {
              $rb.trigger("destroy.owl.carousel").removeClass("owl-carousel owl-loaded");
            }
          });
        }

        if ($("#private-hire-corp").length > 0) {
          resize();
          $(window).on("load resize", function() {
            resize();
          });

          imageSlider();
          $(window).on("load", imageSlider);
          window.matchMedia("(max-width: 767px)").addEventListener("change", imageSlider);
        }

        $("#page-private-hire .buttons .btn-gradient[href='#private-hire-enquiry']").click(function() {
          $('html, body').animate({
            scrollTop: $("#private-hire-enquiry").offset().top - $("header").outerHeight()
          }, 2000);
          return false;
        });
        $("#ContactFormFirstName, #ContactFormSecondName").change(function() {
          $("#ContactFormName").val($("#ContactFormFirstName").val() + " " + $("#ContactFormSecondName").val());
        });
      },

      storyPage: function() {
        function resize() {
          $("#story-sustain .left-box .background").css("left", "0px").css("right", "0px");
          var left = $("#story-sustain .left-box .background").offset().left;
          var right = $("body").outerWidth() - $("#story-sustain .left-box .background").offset().left - $("#story-sustain .left-box .background").outerWidth();
          $("#story-sustain .left-box .background").css("left", "-" + left + "px").css("right", "-" + right + "px");
        }

        function imageSlider() {
          $("#story-sustain .right-box").each(function () {
            var $rb = $(this);
            var mobile = window.matchMedia("(max-width: 767px)").matches;
            var inited = $rb.hasClass("owl-loaded");
            if (mobile && !inited && $rb.find(".item").length > 1) {
              $rb.addClass("owl-carousel").owlCarousel({ items: 1, margin: 20, nav: false, autoplay: false });
            } else if (!mobile && inited) {
              $rb.trigger("destroy.owl.carousel").removeClass("owl-carousel owl-loaded");
            }
          });
        }

        if ($("#story-sustain").length > 0) {
          resize();
          $(window).on("load resize", function() {
            resize();
          });

          imageSlider();
          $(window).on("load", imageSlider);
          window.matchMedia("(max-width: 767px)").addEventListener("change", imageSlider);
        }

        $("#ContactFormFirstName, #ContactFormSecondName").change(function() {
          $("#ContactFormName").val($("#ContactFormFirstName").val() + " " + $("#ContactFormSecondName").val());
        });

        $("#story-video .right .image").click(function () {
          $("#story-video .right").addClass("active");
          $("#story-video .right video").each(function() {
            $(this).get(0).play();
          });
          $("#story-video .right iframe").each(function() {
            var iframe = $(this)[0],
                player = $f(iframe);
            player.addEvent('ready', function() {
              player.api('play');
            });
          });
        });
      },

      franchisePage: function() {
        $("#franchise-why ul li a").click(function() {
          var index = $(this).attr("data-index");
          $("#franchise-why ul li a").removeClass("active");
          $(this).addClass("active");
          $("#franchise-why .images .image").removeClass("active");
          $("#franchise-why .images .image[data-index='" + index + "']").addClass("active");
          return false;
        });
        $("#page-franchise .buttons .btn-gradient[href='#private-hire-enquiry']").click(function() {
          $('html, body').animate({
            scrollTop: $("#private-hire-enquiry").offset().top - $("header").outerHeight()
          }, 2000);
          return false;
        });
        $("#ContactFormFirstName, #ContactFormSecondName").change(function() {
          $("#ContactFormName").val($("#ContactFormFirstName").val() + " " + $("#ContactFormSecondName").val());
        });
      },

      faqPage: function() {
        $("#faq-page .faq-item summary").off("click.faq").on("click.faq", function(e) {
          e.preventDefault();
          var $item = $(this).closest(".faq-item");
          var $answer = $item.find(".faq-answer");

          if ($item.prop("open")) {
            $answer.stop(true, false).slideUp(300, function() {
              $item.prop("open", false);
            });
          } else {
            $item.prop("open", true);
            $answer.stop(true, false).hide().slideDown(300);
          }
        });
      },

      services2Page: function() {
        if($(".js-first-services").length > 0 && $(".js-services-1-section").length > 0) {
          $(".js-first-services").html($(".js-services-1-section").html());
          $(".js-services-1-section").remove();
        }
        if($(".js-second-services").length > 0 && $(".js-services-2-section").length > 0) {
          $(".js-second-services").html($(".js-services-2-section").html());
          $(".js-services-2-section").remove();
        }
        if($(".js-third-services").length > 0 && $(".js-services-3-section").length > 0) {
          $(".js-third-services").html($(".js-services-3-section").html());
          $(".js-services-3-section").remove();
        }
      },

      // Scripts, effects
      lazyImages: function() {
        function isRetina() {
          return window.devicePixelRatio > 1;
        }

        function isMobile() {
          if($(document).outerWidth() > 767) { return false; } else { return true; }
        }

        $(".lazy-img").each(function () {
          var element = $(this);
          var interval = setInterval(function () {
            if($(element).isInViewport() || $(element).hasClass("immediately")) {
              var src = $(element).attr("data-src");
              if(isRetina() && isMobile() && $(element).attr("data-retina-mobile-src") != undefined) src = $(element).attr("data-retina-mobile-src");
              if(!isRetina() && isMobile() && $(element).attr("data-mobile-src") != undefined) src = $(element).attr("data-mobile-src");
              if(isRetina() && !isMobile() && $(element).attr("data-retina-src") != undefined) src = $(element).attr("data-retina-src");
              if(src == '') src = $(element).attr("data-src");
              $(element).attr("src", src);
              $(element).parent().waitForImages(function() {
                $(element).parent().addClass("active");
                clearInterval(interval);
              });
            }
          }, 100);
        });
      },

      addToCartGrid: function() {
        $(document).on('click', '.variants button, .add-variant', function(){
          var quantity = $(this).attr("data-quantity");
          var id = $(this).attr("data-variant-id");
          $(this).addClass("loading");
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: { id: id, quantity: quantity },
            success: function() {
              duck_and_dry.refreshCart();
            },
            error: function(response) {
              var errorMessage = response.responseJSON
                ? response.responseJSON.description
                : theme.strings.cartError;
              alert(errorMessage);
              duck_and_dry.refreshCart();
            }
          });
          return false;
        });
      },

      buttonHoverEffect: function() {
        $(".button").hover(function(evt) {
          var x = evt.pageX - $(this).offset().left;
          var y = evt.pageY - $(this).offset().top;
          $(this).find("span").css("left", x).css("top", y);
        }, function(evt) {
          var x = evt.pageX - $(this).offset().left;
          var y = evt.pageY - $(this).offset().top;
          $(this).find("span").css("left", x).css("top", y);
        });
      },

      refreshCart: function() {
        $('header .right .cart').addClass("loading");
        $('header .right .cart .cart-content').load('/cart #cart-content', function() {
          $('header .right .cart').removeClass("loading");
          $("#product .product-template .right .form-button, .product-item .meta .variants button, .add-variant").removeClass("loading");
          setTimeout(function () {
            $('header .right .cart').addClass("active");
          }, 400);
        });
        jQuery.getJSON('/cart.js', function(cart) {
          // CHANGED: build / update / remove the badge instead of just setting text.
          // - empty cart -> badge removed entirely (no "0")
          // - first item added -> badge created even if it wasn't in the DOM
          var $cartCount = $('header .right .cart .cart-count');
          var $badge = $cartCount.find('.cart-badge');
          if (cart.item_count > 0) {
            if ($badge.length === 0) {
              $badge = $('<span class="cart-badge"></span>').appendTo($cartCount);
            }
            $badge.text(cart.item_count);
          } else {
            $badge.remove();
          }
        });
      },

      changeQuantity: function() {
        $("body").on("click", "header .right .cart .cart-content ul.items li .right .quantity a, header .right .cart .cart-content ul.items li .right .remove a", function() {
          $('header .right .cart').addClass("loading");
          var id = $(this).attr("data-variant-id");
          var quantity = parseInt($(this).attr("data-quantity"));
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: { id: id, quantity: quantity },
            success: function() {
              duck_and_dry.refreshCart();
            },
            error: function(response) {
              var errorMessage = response.responseJSON
                ? response.responseJSON.description
                : theme.strings.cartError;
              alert(errorMessage);
              duck_and_dry.refreshCart();
            }
          });
          return false;
        });
      },

      detectBrowser: function() {
        if(navigator.userAgent.search("Safari") >= 0 && navigator.userAgent.search("Chrome") < 0) {
          $("body").addClass("safari");
        }
      }
    }
  })();
})(jQuery);

$(document).ready(function() {
  duck_and_dry.init();
});

if (window.Shopify.designMode) {
  jQuery(document)
    .on('shopify:section:load', function() {
      duck_and_dry.init();
    }).on('shopify:section:unload', function() {
      duck_and_dry.init();
    }).on('shopify:section:select', function() {
      duck_and_dry.init();
    }).on('shopify:section:deselect', function() {
      duck_and_dry.init();
    }).on('shopify:block:select', function() {
      duck_and_dry.init();
    }).on('shopify:block:deselect', function() {
      duck_and_dry.init();
    });
}